import ConfirmPanel from './ConfirmPanel';

export default ConfirmPanel;



// WEBPACK FOOTER //
// ./src/views/components/Common/ConfirmPanel/index.js